const noBodyMethods = ["GET", "HEAD"];

const formatBodyAndHeader = (method: string, data: any, header: any) => {
  let formattedData = data;
  let formattedHeader = header;
  if (data?.constructor === Object) {
    formattedData = JSON.stringify(data);
    formattedHeader = {
      ...header,
      "Content-Type": "application/json; charset=utf-8",
    };
  }
  if (data?.constructor === FormData) {
    formattedHeader = { "Content-Type": "application/x-www-form-urlencoded" };
  }
  if (!data || noBodyMethods.indexOf(method) > -1) {
    formattedData = undefined;
  }
  return { body: formattedData, headers: formattedHeader };
};

const fetcher = async (method: string, url: string, data: any, header: any) => {
  const { body, headers } = formatBodyAndHeader(method, data, header);
  const requestParams =
    noBodyMethods.indexOf(method) > -1
      ? { method, headers }
      : { method, body, headers };
  const response = await fetch(url, {
    ...requestParams,
  });
  return new Promise((resolve, reject) => {
    if (response.status === 204) {
      resolve({ data: {} });
    }
    try {
      if (response.ok) {
        response
          .json()
          .then((responseData) => {
            return resolve({ data: responseData });
          })
          .catch(() => {
            resolve({});
          });
      } else {
        reject(response);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const postRequest = async (
  url: string,
  data: any,
  headers: Record<string, unknown> = {}
) => {
  return fetcher("POST", url, data, headers);
};
